import { clsx } from "clsx";
import * as m from "motion/react-m";
import { AnimatePresence } from "motion/react";
import { ConvAITerms } from "@ui/components/demos/ConvAI/ConvAITermsModal";

export function AgentTermsOverlay({
  showTermsFor,
  onAgree,
  onClose,
  showGradients = true,
  scrollOnCard = false,
}: {
  showTermsFor: "text" | "voice" | null;
  onAgree: () => void;
  onClose: () => void;
  showGradients?: boolean;
  /** When true, the overlay itself doesn't scroll -- the parent card handles scrolling */
  scrollOnCard?: boolean;
}) {
  return (
    <AnimatePresence initial={false}>
      {showTermsFor !== null && (
        <m.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { delay: 0.15 } }}
          exit={{ opacity: 0 }}
          className={clsx(
            "tw-bg-cream tw-rounded-3xl sm:tw-bg-transparent tw-absolute tw-z-20 tw-inset-0 tw-px-6 tw-flex tw-flex-col tw-items-center tw-justify-center md:tw-pb-6 tw-pointer-events-auto",
            !scrollOnCard && "tw-overflow-y-auto",
          )}
        >
          <div className='tw-min-h-0 tw-max-w-md'>
            {showGradients && <div className='tw-sticky tw-top-0 tw-bg-gradient-to-b tw-from-cream tw-h-6' />}
            <ConvAITerms onAgree={onAgree} onClose={onClose} />
            {showGradients && <div className='tw-sticky tw-bottom-0 tw-bg-gradient-to-t tw-from-cream tw-h-6' />}
          </div>
        </m.div>
      )}
    </AnimatePresence>
  );
}
